<template>
    <div class="makeContent">
        <div class="makeTitle">
            {{$translate('lang.E3202103030007', { defaultText: '工厂制造' })}}
            <span class="line"></span>
        </div>
        <el-tabs @tab-click="handleClick" v-model='activeName'>
            <el-tab-pane :label="$translate('lang.E3202103030018', { defaultText: '原材料' })" name="first">
                <el-row>
                    <el-col :span='item.span' class="itemRow" v-for="(item,index) in makeList" :key='index'>
                        <div class="labelText" :title='item.label'>{{item.label}}</div>
                        <el-tooltip effect="dark" :content='item.value' placement="top" v-if='item["value"].length > 34'>
                            <span class="valueText unitValueText">{{item.value}}</span>
                        </el-tooltip>
                        <div class="valueText" v-else>{{item.value}}</div>
                    </el-col>
                </el-row>
                <div class="bomTitle">
                    {{$translate('lang.E3202103040008', { defaultText: '关键BOM物料' })}}：
                </div>
                <div class="bomTotal">
                    <el-row class="commomPaper bomItem" v-for="(item,index) in bomArr" :key='index'>
                        <el-col :span='8' class="itemRow">
                            <div class="labelText" :title="$translate('lang.E3202103040009', { defaultText: '物料编号' })">{{$translate('lang.E3202103040009', { defaultText: '物料编号' })}}</div>
                            <div class="valueText">{{item.mitem_CODE}}</div>
                        </el-col>
                        <el-col :span='8' class="itemRow">
                            <div class="labelText" :title="$translate('lang.E3202103040010', { defaultText: '物料名称' })">{{$translate('lang.E3202103040010', { defaultText: '物料名称' })}}</div>
                            <el-tooltip effect="dark" :content='item.mitem_DESC' placement="top" v-if='item["mitem_DESC"] && item["mitem_DESC"].length > 34'>
                                <span class="valueText unitValueText">{{item.mitem_DESC}}</span>
                            </el-tooltip>
                            <div class="valueText" v-else>{{item.mitem_DESC}}</div>
                        </el-col>
                        <el-col :span='8' class="itemRow">
                            <div class="labelText" :title="$translate('lang.E3202103040011', { defaultText: '供应商' })">{{$translate('lang.E3202103040011', { defaultText: '供应商' })}}</div>
                            <el-tooltip effect="dark" :content='item.supplier_NAME' placement="top" v-if='item["supplier_NAME"]&&item["supplier_NAME"].length > 34'>
                                <span class="valueText unitValueText">{{item.supplier_NAME}}</span>
                            </el-tooltip>
                            <div class="valueText" v-else>{{item.supplier_NAME}}</div>
                        </el-col>
                    </el-row>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$translate('lang.E3202103030019', { defaultText: '部件' })" name="second">
                <el-row class="commomHead">
                    <el-col :span='item.span' class="itemRow" v-for="(item,index) in partsList" :key='index'>
                        <div class="labelText" :title='item.label'>{{item.label}}</div>
                        <el-tooltip effect="dark" :content='item.value' placement="top" v-if='item["value"].length > 34'>
                            <span class="valueText unitValueText">{{item.value}}</span>
                        </el-tooltip>
                        <div class="valueText" v-else>{{item.value}}</div>
                    </el-col>
                </el-row>
                <el-row class="commomPaper partsItem" v-for="(item,index) in keyArr" :key='index'>
                    <el-col :span='8' class="itemRow">
                        <div class="labelText" :title="$translate('lang.E3202103040003', { defaultText: '关键件条码' })">{{$translate('lang.E3202103040003', { defaultText: '关键件条码' })}}</div>
                        <div class="valueText">{{item.material_SN}}</div>
                    </el-col>
                    <el-col :span='8' class="itemRow">
                        <div class="labelText" :title="$translate('lang.E3202103040004', { defaultText: '采集时间' })">{{$translate('lang.E3202103040004', { defaultText: '采集时间' })}}</div>
                        <div class="valueText">{{item.datetime_CREATED}}</div>
                    </el-col>
                    <el-col :span='8' class="itemRow">
                        <div class="labelText" :title="$translate('lang.E3202103040005', { defaultText: '关键件编码' })">{{$translate('lang.E3202103040005', { defaultText: '关键件编码' })}}</div>
                        <div class="valueText">{{item.mitem_CODE}}</div>
                    </el-col>
                    <el-col :span='24' class="itemRow">
                        <div class="labelText" :title="$translate('lang.E3202103040006', { defaultText: '关键件描述' })">{{$translate('lang.E3202103040006', { defaultText: '关键件描述' })}}</div>
                        <el-tooltip effect="dark" :content='item.val3' placement="top" v-if='item["mitem_DESC"] && item["mitem_DESC"].length > 60'>
                            <span class="valueText unitValueText">{{item.mitem_DESC}}</span>
                        </el-tooltip>
                        <div class="valueText" v-else>{{item.mitem_DESC}}</div>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { searchMaterial, searchParts } from '../../../../api/productProcess.js';
export default {
    props: {
    },
    data () {
        return {
            activeName: 'first',
            proNum: '',
            flag: false,
            bomArr: [],
            keyArr: [],
            makeList: [{
                span: 8,
                label: this.$translate('lang.E3202103030020', { defaultText: '产品编号' }),
                value: '',
                key: 'mitem_CODE'
            }, {
                span: 16,
                label: this.$translate('lang.E3202103030021', { defaultText: '产品描述' }),
                value: '',
                key: 'mitem_DESC'
            }, {
                span: 8,
                label: this.$translate('lang.E3202103030022', { defaultText: '工单号' }),
                value: '',
                key: 'mo_NAME'
            }, {
                span: 8,
                label: this.$translate('lang.E3202202230001', { defaultText: '车间名称' }),
                value: '',
                key: 'workshop_DESC'
            }, {
                span: 8,
                label: this.$translate('lang.E3202202230002', { defaultText: '产线名称' }),
                value: '',
                key: 'line_DESC'
            }],
            partsList: [{
                span: 8,
                label: this.$translate('lang.E3202103030020', { defaultText: '产品编号' }),
                value: '',
                key: 'mitem_CODE'
            }, {
                span: 16,
                label: this.$translate('lang.E3202103030021', { defaultText: '产品描述' }),
                value: '',
                key: 'mitem_DESC'
            }, {
                span: 8,
                label: this.$translate('lang.E3202103030022', { defaultText: '工单号' }),
                value: '',
                key: 'mo_NAME'
            }, {
                span: 8,
                label: this.$translate('lang.E3202202230001', { defaultText: '车间名称' }),
                value: '',
                key: 'workshop_DESC'
            }, {
                span: 8,
                label: this.$translate('lang.E3202202230002', { defaultText: '产线名称' }),
                value: '',
                key: 'line_DESC'
            }]
        };
    },
    methods: {
        handleClick(tab, event) {
        },
        initData() {
            this.makeList.forEach(item => {
                item.value = '';
            });
            this.partsList.forEach(item => {
                item.value = '';
            });
            this.mitem_KEYPART = [];
            this.bomArr = [];
            this.keyArr = [];
        },
        setproNum(proNum) {
            this.activeName = 'first';
            this.proNum = proNum;
            this.flag = true;
        },
        // 获取工厂制造详细信息
        getMessage() {
            if (this.flag) {
                this.initData();
                searchMaterial(this.proNum).then(res => {
                    if (res.code === '0' && res.data) {
                        const { data } = res;
                        Object.keys(data).map(item => {
                            this.makeList.forEach(item2 => {
                                if (item2.key === item) {
                                    item2.value = data[item];
                                }
                            });
                            return item;
                        });
                        this.bomArr = data.mo_BOM;
                    }
                    this.flag = false;
                });
                searchParts(this.proNum).then(res => {
                    if (res.code === '0' && res.data) {
                        const { data } = res;
                        Object.keys(data).map(item => {
                            this.partsList.forEach(item2 => {
                                if (item2.key === item) {
                                    item2.value = data[item];
                                }
                            });
                            return item;
                        });
                        const keyArr = data.mitem_KEYPART;
                        this.keyArr = keyArr;
                    }
                    this.flag = false;
                });
            }
        }
    }
};
</script>
<style lang="less">
.makeContent {
    .commomHead {
        margin-bottom: 14px;
    }
    .makeTitle {
        position: absolute;
        top: 8px;
        left: 5px;
        font-weight: 700;
        color: #333;
    }
    .el-tabs__nav-wrap {
        box-sizing: border-box;
        padding-left: 140px;
    }
    .bomTitle {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        color: #333;
        font-weight: 700;
    }
    .bomItem {
        margin-bottom: 10px;
    }
    .bomTotal {
        max-height: 40vh;
        overflow: auto;
    }
    .partsItem {
        padding: 10px;
        margin-bottom: 10px;
    }
}
</style>